module.exports = __webpack_public_path__ + "img/logo-nav.5a64992d.png";